"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClayPortal", {
  enumerable: true,
  get: function get() {
    return _Portal.ClayPortal;
  }
});
Object.defineProperty(exports, "FOCUSABLE_ELEMENTS", {
  enumerable: true,
  get: function get() {
    return _useFocusManagement.FOCUSABLE_ELEMENTS;
  }
});
Object.defineProperty(exports, "FocusScope", {
  enumerable: true,
  get: function get() {
    return _FocusScope.FocusScope;
  }
});
Object.defineProperty(exports, "Keys", {
  enumerable: true,
  get: function get() {
    return _Keys.Keys;
  }
});
Object.defineProperty(exports, "LinkOrButton", {
  enumerable: true,
  get: function get() {
    return _LinkOrButton.LinkOrButton;
  }
});
Object.defineProperty(exports, "MouseSafeArea", {
  enumerable: true,
  get: function get() {
    return _MouseSafeArea.MouseSafeArea;
  }
});
Object.defineProperty(exports, "delegate", {
  enumerable: true,
  get: function get() {
    return _delegate.delegate;
  }
});
Object.defineProperty(exports, "doAlign", {
  enumerable: true,
  get: function get() {
    return _doAlign.doAlign;
  }
});
Object.defineProperty(exports, "getEllipsisItems", {
  enumerable: true,
  get: function get() {
    return _getEllipsisItems.getEllipsisItems;
  }
});
exports.noop = void 0;
Object.defineProperty(exports, "observeRect", {
  enumerable: true,
  get: function get() {
    return _observeRect.observeRect;
  }
});
Object.defineProperty(exports, "setElementFullHeight", {
  enumerable: true,
  get: function get() {
    return _setElementFullHeight.setElementFullHeight;
  }
});
Object.defineProperty(exports, "sub", {
  enumerable: true,
  get: function get() {
    return _sub.sub;
  }
});
Object.defineProperty(exports, "useDebounce", {
  enumerable: true,
  get: function get() {
    return _useDebounce.useDebounce;
  }
});
Object.defineProperty(exports, "useFocusManagement", {
  enumerable: true,
  get: function get() {
    return _useFocusManagement.useFocusManagement;
  }
});
Object.defineProperty(exports, "useInternalState", {
  enumerable: true,
  get: function get() {
    return _useInternalState.useInternalState;
  }
});
Object.defineProperty(exports, "useMousePosition", {
  enumerable: true,
  get: function get() {
    return _useMousePosition.useMousePosition;
  }
});

var _Portal = require("./Portal");

var _delegate = require("./delegate");

var _doAlign = require("./doAlign");

var _FocusScope = require("./FocusScope");

var _getEllipsisItems = require("./getEllipsisItems");

var _Keys = require("./Keys");

var _LinkOrButton = require("./LinkOrButton");

var _sub = require("./sub");

var _observeRect = require("./observeRect");

var _useDebounce = require("./useDebounce");

var _useFocusManagement = require("./useFocusManagement");

var _setElementFullHeight = require("./setElementFullHeight");

var _useInternalState = require("./useInternalState");

var _useMousePosition = require("./useMousePosition");

var _MouseSafeArea = require("./MouseSafeArea");

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var noop = function noop() {};

exports.noop = noop;